import React, { useState } from 'react';

export default function AdminProfileModal({ admin, closeModal }) {
    const [activeTab, setActiveTab] = useState('personal');

    // Helper Styles
    const modalOverlayStyle = {
        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
        backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000
    };
    const modalContentStyle = {
        backgroundColor: 'white', width: '90%', maxWidth: '700px', height: '80%', 
        borderRadius: '12px', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxShadow: '0 10px 25px rgba(0,0,0,0.2)'
    };
    const tabBtnStyle = (tabName) => ({
        padding: '15px 20px', border: 'none', cursor: 'pointer', background: 'transparent',
        borderBottom: activeTab === tabName ? '3px solid #0056b3' : '3px solid transparent',
        fontWeight: activeTab === tabName ? 'bold' : '500',
        color: activeTab === tabName ? '#0056b3' : '#666',
        textTransform: 'capitalize'
    });

    // Helper Component for Fields
    const Field = ({ label, value }) => (
        <div style={{ marginBottom: '15px', flex: '1 0 45%', minWidth: '200px' }}>
            <label style={{ display: 'block', fontSize: '11px', textTransform: 'uppercase', color: '#888', marginBottom: '4px', fontWeight: 'bold' }}>{label}</label>
            <div style={{ fontSize: '15px', fontWeight: '500', color: '#333' }}>{value || '-'}</div>
        </div>
    );

    // Helper for Badges (Permissions)
    const Badge = ({ text, color }) => (
        <span style={{ 
            padding: '4px 10px', borderRadius: '15px', fontSize: '12px', fontWeight: 'bold',
            backgroundColor: color === 'green' ? '#e6fffa' : '#ebf8ff',
            color: color === 'green' ? '#2c7a7b' : '#2b6cb0',
            border: `1px solid ${color === 'green' ? '#b2f5ea' : '#bee3f8'}`,
            marginRight: '8px', marginBottom: '8px', display: 'inline-block'
        }}>
            {text}
        </span>
    );

    return (
        <div style={modalOverlayStyle} onClick={closeModal}>
            <div style={modalContentStyle} onClick={(e) => e.stopPropagation()}>
                
                {/* Header */}
                <div style={{ padding: '20px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#f8f9fa' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img 
                            src={admin.profilePicture || 'https://via.placeholder.com/150'} 
                            alt="Profile" 
                            style={{ width: '50px', height: '50px', borderRadius: '50%', marginRight: '15px', objectFit: 'cover', border: '2px solid #ddd' }} 
                        />
                        <div>
                            <h2 style={{ margin: 0, fontSize: '18px', color: '#333' }}>{admin.fullName}</h2>
                            <p style={{ margin: '2px 0 0', fontSize: '13px', color: '#666' }}>@{admin.username}</p>
                        </div>
                    </div>
                    <button onClick={closeModal} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#999' }}>×</button>
                </div>

                {/* Tabs */}
                <div style={{ display: 'flex', background: 'white', padding: '0 10px', borderBottom: '1px solid #eee', overflowX: 'auto' }}>
                    {['personal', 'address', 'employment', 'financial', 'permissions'].map(tab => (
                        <button key={tab} onClick={() => setActiveTab(tab)} style={tabBtnStyle(tab)}>{tab}</button>
                    ))}
                </div>

                {/* Content */}
                <div style={{ flex: 1, overflowY: 'auto', padding: '30px' }}>
                    
                    {activeTab === 'personal' && (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
                            <Field label="Full Name" value={admin.fullName} />
                            <Field label="Username" value={admin.username} />
                            <Field label="Email" value={admin.email} />
                            <Field label="Phone Number" value={admin.phoneNumber} />
                            <Field label="Date of Birth" value={admin.dob} />
                            <Field label="Gender" value={admin.gender} />
                            <Field label="Nationality" value={admin.nationality} />
                            <Field label="Religion" value={admin.religion} />
                        </div>
                    )}

                    {activeTab === 'address' && (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
                            <div style={{ width: '100%' }}>
                                <Field label="Full Address String" value={admin.address?.fullAddress || `${admin.address?.street || ''}, ${admin.address?.town || ''}`} />
                            </div>
                            <Field label="Street / Line 1" value={admin.address?.street} />
                            <Field label="Town / City" value={admin.address?.town} />
                            <Field label="County" value={admin.address?.county} />
                            <Field label="Postcode" value={admin.address?.postalCode} />
                            <Field label="Country" value={admin.address?.country} />
                        </div>
                    )}

                    {activeTab === 'employment' && (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
                            <Field label="Job Role" value={admin.jobRole} />
                            <Field label="Contract Type" value={admin.contractType} />
                            <Field label="Employment Status" value={admin.employmentStatus} />
                            <Field label="Working Hours" value={admin.workingHours} />
                            <Field label="Branch Code" value={admin.branchCode} />
                            <Field label="Last Seen" value={admin.lastSeen?.toDate ? new Date(admin.lastSeen.toDate()).toLocaleString() : 'Never'} />
                        </div>
                    )}

                    {activeTab === 'financial' && (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
                            <Field label="NI Number" value={admin.niNumber} />
                            <Field label="Income Tax Rate" value={admin.incomeTaxRate} />
                            <div style={{ width: '100%', height: '1px', background: '#eee', margin: '10px 0' }}></div>
                            <Field label="Pension ID" value={admin.pension?.pensionID} />
                            <Field label="Pension Status" value={admin.pension?.pensionStatus} />
                            <Field label="Student Loan" value={admin.studentLoan?.status || admin.studentLoan?.name} />
                        </div>
                    )}

                    {activeTab === 'permissions' && (
                        <div>
                            <h4 style={{ margin: '0 0 15px', color: '#444', fontSize: '14px', textTransform: 'uppercase' }}>System Access</h4>
                            <div style={{ marginBottom: '25px' }}>
                                {admin.permissionLevels && admin.permissionLevels.length > 0 ? (
                                    admin.permissionLevels.map(role => <Badge key={role} text={role} color={role === 'Super Admin' ? 'green' : 'blue'} />)
                                ) : <span style={{ color: '#999' }}>No explicit roles assigned.</span>}
                            </div>

                            <h4 style={{ margin: '0 0 15px', color: '#444', fontSize: '14px', textTransform: 'uppercase' }}>Custom Form / Department Levels</h4>
                            <div>
                                {admin.CustomFormLevel && admin.CustomFormLevel.length > 0 ? (
                                    admin.CustomFormLevel.map(role => <Badge key={role} text={role} color="blue" />)
                                ) : <span style={{ color: '#999' }}>No custom levels assigned.</span>}
                            </div>
                        </div>
                    )}

                </div>

                {/* Footer */}
                <div style={{ padding: '20px', borderTop: '1px solid #eee', textAlign: 'right', backgroundColor: '#f8f9fa' }}>
                    <button onClick={closeModal} style={{ padding: '10px 25px', backgroundColor: '#0056b3', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' }}>Close</button>
                </div>
            </div>
        </div>
    );
}